import scssVariables from "@/assets/styles/variables.scss"
import determineTextColor from "@/lib/determine-text-color"

class Theme {
  constructor() {
    this.options = {
      "--brand-color-hex": "#2b54c7",
      "--brand-color-rgb-vals": "24, 84, 199",
      "--button-text-color-hex": "#fff",
      "--border-radius": "6px",
      "--input-border-radius": "12px",
      "--card-shadow": scssVariables["box-shadow--small"]
    }
  }

  set(attribute, value) {
    if (!this.options[attribute]) throw "Invalid Theme Attribute"

    this.options[attribute] = value
  }

  insert() {
    let el = document.createElement("style")
    el.type = "text/css"

    el.appendChild(document.createTextNode(this.toString()))
    document.head.appendChild(el)
  }

  toString() {
    let css = ":root {\n"

    Object.keys(this.options).forEach(key => {
      css += `${key}: ${this.options[key]};\n`
    })

    css += "}"

    return css
  }
}

export default ({ app_look, brand_color, card_style, default_color_mode }) => {
  const theme = new Theme()

  if (app_look) {
    switch (app_look) {
      case "rounded":
        theme.set("--input-border-radius", "24px")
        theme.set("--border-radius", "16px")
        break
      case "square":
        theme.set("--input-border-radius", "3px")
        theme.set("--border-radius", "3px")
        break
      default:
        break
    }
  }

  if (card_style) {
    switch (card_style) {
      case "raised":
        theme.set("--card-shadow", scssVariables["box-shadow--large"])
        break
      case "flat":
        theme.set("--card-shadow", scssVariables["box-shadow--keyline"])
        break
      default:
        break
    }
  }

  if (brand_color) {
    const rgbVals = brand_color.rgb.replace(/rgb\(/, "").replace(")", "")

    theme.set("--brand-color-hex", brand_color.hex)
    theme.set("--brand-color-rgb-vals", rgbVals)
    theme.set(
      "--button-text-color-hex",
      determineTextColor(brand_color.hex, {
        black: scssVariables["color-ui--grey-80"],
        white: "#fff"
      })
    )
  }

  if (default_color_mode === "dark") {
    document.body.classList.add("--dark-mode")
  } else {
    document.body.classList.remove("--dark-mode")
  }

  theme.insert()
}
